import { cloneDeep } from 'lodash';
import BlocksList from '../../../data/constant/BlocksList';

// blocks.name is a varchar(64): a longer name makes the server refuse the block
const BLOCK_NAME_MAX_LENGTH = 64;

const blockName = (prefix, text) => {
    const name = prefix + String(text).replace(/\s+/g, ' ').trim();
    return name.length > BLOCK_NAME_MAX_LENGTH ? name.slice(0, BLOCK_NAME_MAX_LENGTH - 1) + '…' : name;
};

export const makeBlankChild = () => ({ text: '', index: null, object_id: null, parent_block_id: null });

export const buildAskSayBlock = (step) => {
    const block = cloneDeep(BlocksList['propos']);
    block.tree.name = blockName(step.type === 'ask' ? 'Ask: ' : 'Say: ', step.message);
    block.tree.data.messages = [{ type: 'text', content: step.message }];
    block.server.messages = block.tree.data.messages;
    return block;
};

// Quick responses: one child per button, its text must equal the response content
export const buildChoiceAskBlock = (step) => {
    const block = cloneDeep(BlocksList['propos']);
    block.tree.name = blockName('Ask: ', step.message);
    block.tree.data.messages = [{ type: 'text', content: step.message }];
    block.tree.data.responses = step.choices.map((choice) => ({ type: 'quick', content: choice.label }));
    block.tree.children = [makeBlankChild(), ...step.choices.map((choice) => ({ text: choice.label, index: null, object_id: null, parent_block_id: null }))];
    block.server.messages = block.tree.data.messages;
    block.server.responses = block.tree.data.responses;
    return block;
};

export const isChoiceAsk = (step) => step.type === 'ask' && Array.isArray(step.choices) && step.choices.length > 0;

export const buildAnnouncementBlock = (step) => {
    const block = cloneDeep(BlocksList['announcement']);
    block.tree.name = blockName('Announcement: ', step.message);
    block.tree.data.message = step.message;
    block.server.message = step.message;
    return block;
};

// A single blank child is exempt from the unlinked-child check (useErrorCheckEditor)
export const buildTerminalStatementBlock = (step) => {
    const block = cloneDeep(BlocksList['propos']);
    block.tree.name = blockName('End: ', step.message);
    block.tree.data.messages = [{ type: 'text', content: step.message }];
    block.server.messages = block.tree.data.messages;
    block.tree.children = [makeBlankChild()];
    return block;
};

export const buildScenarioBlock = (group) => {
    const block = cloneDeep(BlocksList['scenario']);
    block.tree.name = group.name;
    return block;
};

export const buildJumpBlock = () => {
    const block = cloneDeep(BlocksList['magic']);
    block.tree.name = 'Jump';
    return block;
};

const ACTION_BLOCK_SIZE = { width: 5, height: 3 };

export const buildConditionBlock = () => {
    const block = cloneDeep(BlocksList['condition']);
    // Condition children need a leading blank child so Vrai and Faux land on indexes 1 and 2
    block.tree.children = [makeBlankChild(), ...block.tree.children];
    Object.assign(block.tree, ACTION_BLOCK_SIZE);
    return block;
};

export const buildCategorizationBlock = (step) => {
    const block = cloneDeep(BlocksList['categorization']);
    const branchChildren = step.branches.map((_, i) => ({ text: 'Branch_' + i, index: null, object_id: null, parent_block_id: null }));
    block.tree.children = [makeBlankChild(), ...branchChildren, { text: 'Default', index: null, object_id: null, parent_block_id: null }];
    return block;
};

export const buildSetVarBlock = () => {
    const block = cloneDeep(BlocksList['set_var']);
    block.tree.children = [makeBlankChild()];
    Object.assign(block.tree, ACTION_BLOCK_SIZE);
    return block;
};

export const buildApiBlock = () => {
    const block = cloneDeep(BlocksList['api']);
    block.tree.children = [makeBlankChild()];
    Object.assign(block.tree, ACTION_BLOCK_SIZE);
    return block;
};
